<template>
    <transition name="modal-fade">
        <div class="modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content">
                    <input type="file" class="form-control" multiple="true" @change="onFileChanged($event)"/>
                    <div class="modal-footer">
                        <button v-bind:class="[buttonLoading, syncLoading]" type="button" disabled>
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            {{ $t('loading') }}
                        </button>
                        <button type="button" class="btn btn-secondary" @click="close" data-dismiss="modal" >
                            {{ $t('close') }}
                        </button>
                        <button type="button" class="btn btn-primary" @click="uploadFiles" >
                            {{ $t('upload') }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import DatasetApi from "../../api/server/dataset";

export default {
    name: "DatasetXlsxUploadDialog",
    props: {
        datasetId: {
            type: Number,
            required: true
        },
        modelingId: {
            type: Number,
            required: true
        }
    },
    methods: {
        onFileChanged(event) {
            const target = event.target;
            if (target && target.files) {
                this.files = target.files;
            }
        },
        close() {
            this.files = [];
            this.$emit("close");
        },
        formatNames(files) {
            return files.length === 1 ? files[0].name : `${files.length} files selected`;
        },
        async uploadFiles() {
            const excelType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
            const allowedExtensions = ['xlsx', 'shp', 'dbf', 'shx', 'cpg', 'prj', 'qmd'];

            try {   
                var result = {}
                this.syncLoading = ""; 
                if (this.files.length > 0) {
                    var file = this.files[0];
                    const extension = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length);
                    if(allowedExtensions.includes(extension)) {
                        if(file.type == excelType) 
                            result = await DatasetApi.datasetXlsxUpload(this.modelingId, this.datasetId, this.files);
                        else 
                            result = await DatasetApi.datasetUpload(this.modelingId, this.datasetId, this.files);
                        
                        if(result.status == 1 || result.status == 2) {
                            this.showError({ title: "Error!", message: result.message, type: "error" });
                            this.close();
                        } else {
                            this.close();
                            this.showSuccess();
                            this.$emit("reload");
                        }
                    } else {
                        this.showErrorWrongFileType()
                    }
                } else {
                    this.showError();
                }
                
                this.buttonLoading = "hidden";
            } catch (e) {
                this.showError({ title: "Error!", message: e.message, type: "error" });
                this.close();
            }
        }
    },
    notifications: {
        showSuccess: { 
            title: 'success',
            message: 'filesUploaded',
            type: 'success'
        },
        showError: { 
            title: 'error',
            message: 'errorWhileUploadingFiles',
            type: 'error'
        },
        showErrorWrongFileType: { 
            title: 'error',
            message: 'errorWhileUploadingFilesWrongType',
            type: 'error'
        }
    },
    data() {
        return {
            hiddenAlert: "hidden",
            buttonLoading: 'btn btn-primary',
            syncLoading: "hidden",
            files: [],
        };
    }
};
</script>